enum RoundingAlgorithm {
	CEIL = 0,
	FLOOR = 1,
}

export default RoundingAlgorithm;
